import React, { useMemo } from 'react';
import AdvancedFilterButton from '../../../../Overview/Components/Filter/AdvancedFilterButton';
import UIStrings from '@/Utils/UIStrings';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import { PossibleMatchScoreRanges } from '../../../api/useIdentifiedProfiles';

const matchScoreRanges: PossibleMatchScoreRanges[] = [
    [0, 24],
    [25, 49],
    [50, 74],
    [75, 100],
];

const MatchScoreFilter = () => {
    const { options, setOptions } = useIdentifiedListContext();

    const resetCallback = () => setOptions((p) => ({ ...p, filters: { ...p.filters, matchScoreRange: undefined } }));

    const menuItems = useMemo<Parameters<typeof AdvancedFilterButton>['0']['menuItems']>(
        () =>
            matchScoreRanges.map(([min, max]) => ({
                id: min.toString(),
                selected: !!options.filters?.matchScoreRange?.find(([selectedMin]) => selectedMin === min),
                changeCallback: () => {
                    resetCallback();
                    const foundIndex = options.filters?.matchScoreRange?.findIndex(
                        ([selectedMin]) => selectedMin === min,
                    );

                    if (typeof foundIndex === 'number' && foundIndex > -1) {
                        setOptions((p) => ({
                            ...p,
                            filters: {
                                ...p.filters,
                                matchScoreRange: p.filters?.matchScoreRange?.toSpliced(foundIndex, 1),
                            },
                        }));
                    } else {
                        const selectedRange = [min, max] as PossibleMatchScoreRanges;

                        setOptions((p) => ({
                            ...p,
                            filters: {
                                ...p.filters,
                                matchScoreRange: p.filters?.matchScoreRange?.toSpliced(0, 0, selectedRange) || [
                                    selectedRange,
                                ],
                            },
                        }));
                    }
                },
                menuItemLabel: `${min}-${max}`,
                isRadio: true,
            })),
        [options, setOptions],
    );

    return <AdvancedFilterButton label={UIStrings.MatchScore} menuItems={menuItems} resetCallback={resetCallback} />;
};

export default MatchScoreFilter;
